import React from 'react'
import { Alert as ReactstrapAlert } from 'reactstrap'

type AlertType = 'primary' | 'secondary' | 'success' | 'danger' | 'warning' | 'info'

const allowedTypes: AlertType[] = ['primary', 'secondary', 'success', 'danger', 'warning', 'info']
const [TYPE_PRIMARY] = allowedTypes

interface AlertProps {
  type?: AlertType
  message: string
  onDismiss?: () => void
}

const Alert: React.FC<AlertProps> = ({ type = TYPE_PRIMARY, message, onDismiss = () => {} }) => (
  <ReactstrapAlert color={type} isOpen toggle={onDismiss}>
    {message}
  </ReactstrapAlert>
)

export default Alert
